import { render, staticRenderFns } from "./model-often-save.vue?vue&type=template&id=664f0fbe&scoped=true"
import script from "./model-often-save.vue?vue&type=script&lang=js"
export * from "./model-often-save.vue?vue&type=script&lang=js"
import style0 from "./model-often-save.vue?vue&type=style&index=0&id=664f0fbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f0fbe",
  null
  
)

export default component.exports